export default {
  title: 'Advisor Centre',
  titlePrefix: '',
  ErrorTitle: 'Technical error',
  ErrorMessage: 'An error has occured. We apologize for the inconvenience.',
  ErrorRetryButton: 'Retry',
  NotFoundTitle: 'Page not found',
  NotFoundMessage: 'Sorry, the page may have been moved or deleted.',
  NotFoundBackButton: 'Back',
};
